import { render } from "./CuadroMando.vue?vue&type=template&id=022bd7aa&scoped=true"
import script from "./CuadroMando.vue?vue&type=script&lang=js"
export * from "./CuadroMando.vue?vue&type=script&lang=js"

import "./CuadroMando.vue?vue&type=style&index=0&id=022bd7aa&lang=css"
import "./CuadroMando.vue?vue&type=style&index=1&id=022bd7aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022bd7aa"]])

export default __exports__